import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute,Router, Routes, RouterModule} from '@angular/router'
import { HttpParams } from '@angular/common/http';
import { LOCALE_ID, Inject } from '@angular/core';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {
loaded: boolean =  false;
siteData: any = [];
siteID = environment.siteID;
productId: any;
loggedIn: boolean = false;
isMondia = false;
mondiaHolder = '';
terms: any;
siteIDValue: number;
operatorID = '';
termsHTML: any;
siteURL = environment['link'];
  constructor(@Inject(LOCALE_ID) protected localeId: string, private route: ActivatedRoute, private http: HttpClient, private router: Router) {this.site() }

  ngOnInit() {
    console.log(this.siteURL)
  }
  ngAfterViewChecked() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.loaded = true;
    }, 2500);
  }
  goSubReg() {
    this.router.navigate(['/subscribe-and-register'], { queryParams: { siteID: this.siteIDValue, operatorID: this.operatorID } });
  }
  public site() {
    this.http.get('https://api-staging.videyo.tv/endpoint/getSite?siteID='+this.siteID, {
    })
      .subscribe(
        data => {
         this.siteData = data;
         console.log('site data');
         console.log(this.siteData);
         this.route.params.subscribe( params2 =>{
          this.productId= params2['productID'];
         })
         if(!this.productId) {
          this.productId = this.siteData['productId'];
         }
         else { 
           this.loggedIn = true;
         }
         this.getTermsConditions();
        },
        error => {
          this.route.params.subscribe( params2 =>{
            this.productId= params2['productID'];
            this.getTermsConditions();
            console.log('mondia holder');
              console.log(this.mondiaHolder);
              this.siteIDValue = params2['siteID'];
              this.operatorID = params2['operatorID'];
              });
              if(this.siteIDValue > 0) { 
                this.isMondia = true;
              }
            }
      );
  }
  refresh(): void {
    window.location.reload();
}
  public getTermsConditions(){
 
    if (window.location.pathname.indexOf('\/en\/') > -1) {
    this.http.get('https://staging.videyo.tv/manage/getTermsAndConditions?siteID='+this.siteID+'&productBillingID='+this.productId+'&siteUrl='+this.siteURL+'&language=en',  {

    })
      .subscribe(
        data => {
         this.terms = data;
         this.termsHTML = this.terms['htmlSource'];
         console.log('terms');
         console.log(this.terms);
        },
        error => {
         
        }
      
      );
  }
  else if (window.location.pathname.indexOf('\/fr\/') > -1) {
    this.http.get('https://staging.videyo.tv/manage/getTermsAndConditions?siteID='+this.siteID+'&productBillingID='+this.productId+'&siteUrl='+this.siteURL+'&language=fr',  {
  
    })
      .subscribe(
        data => {
         this.terms = data;
         this.termsHTML = this.terms['htmlSource'];
         console.log('terms');
         console.log(this.terms);
        },
        error => {
         
        }
      
      );
  }
  else if (window.location.pathname.indexOf('\/ar\/') > -1) {
    this.http.get('https://staging.videyo.tv/manage/getTermsAndConditions?siteID='+this.siteID+'&productBillingID='+this.productId+'&siteUrl='+this.siteURL+'&language=ar',  {
  
    })
      .subscribe(
        data => {
         this.terms = data;
         this.termsHTML = this.terms['htmlSource'];
         console.log('terms');
         console.log(this.terms);
        },
        error => {
         
        }
      
      );
  }
  else {
    this.http.get('https://staging.videyo.tv/manage/getTermsAndConditions?siteID='+this.siteID+'&productBillingID='+this.productId+'&siteUrl='+this.siteURL+'&language=en',  {
  
    })
      .subscribe(
        data => {
         this.terms = data;
         this.termsHTML = this.terms['htmlSource'];
         console.log('terms');
         console.log(this.terms);
        },
        error => {
         
        }
      
      );
  }
}

}

